import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { trackEvent } from './analytics';

export default function ContactForm() {
  const sending = useRef(false);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  async function submit(event) {
    event.preventDefault();
    if (sending.current) return;
    const form = event.currentTarget;
    const { user_name, user_email, user_tel, consent } = form.elements;
    for (const field of [user_name, user_email, user_tel]) field.value = field.value.trim();
    const digits = user_tel.value.replace(/\D/g, '');
    user_tel.setCustomValidity(/^\+?[\d\s()-]+$/.test(user_tel.value) && digits.length >= 8 && digits.length <= 15
      ? '' : '연락 가능한 전화번호를 확인해주세요.');
    if (!form.checkValidity()) {
      const invalid = form.querySelector('input:invalid, textarea:invalid');
      setError(invalid === consent ? '개인정보 수집 및 이용에 동의해주세요.' : '필수 입력 항목과 이메일·전화번호 형식을 확인해주세요.');
      invalid.focus();
      return;
    }
    sending.current = true;
    setStatus('pending');
    setError('');
    try {
      await emailjs.sendForm('service_aw37t4d', 'template_hly2d66', form, 'q-o1WnQB6dOaQAOlQ');
    } catch {
      setStatus('idle');
      setError('신청을 보내지 못했습니다. 입력 내용은 그대로 남아 있으니 다시 시도하거나 02-3272-2302로 전화해주세요.');
      sending.current = false;
      return;
    }
    setStatus('success');
    trackEvent('contact_submit', { page: window.location.pathname });
  }

  if (status === 'success') return (
    <div className="inquiry-success" role="status">
      <span className="inquiry-success-mark" aria-hidden="true">✓</span>
      <h3>상담 신청이 접수되었습니다.</h3>
      <p>남겨주신 연락처로 무료체험과 도입 방법을 안내해 드리겠습니다.</p>
      <a href="tel:0232722302" onClick={() => trackEvent('phone_click', { location: 'body', page: window.location.pathname })}>전화 상담 02-3272-2302</a>
    </div>
  );

  return (
    <form className="inquiry-form" aria-label="도입 상담 신청" noValidate onSubmit={submit} aria-busy={status === 'pending'}>
      <div className="inquiry-form-heading"><h3>도입 상담 신청</h3><span>* 필수 입력</span></div>
      <fieldset disabled={status === 'pending'}>
        <legend className="visually-hidden">상담 신청 정보</legend>
        <div className="inquiry-fields">
          <label htmlFor="inquiry-name">신청자 이름 *<input id="inquiry-name" name="user_name" autoComplete="name" placeholder="이름을 입력해주세요" required maxLength={100} /></label>
          <label htmlFor="inquiry-org">소속 / 회사 <span>(선택)</span><input id="inquiry-org" name="org" autoComplete="organization" placeholder="회사명을 입력해주세요" maxLength={200} /></label>
          <label htmlFor="inquiry-email">이메일 *<input id="inquiry-email" name="user_email" type="email" autoComplete="email" placeholder="name@company.com" required maxLength={254} /></label>
          <label htmlFor="inquiry-tel">전화번호 *<input id="inquiry-tel" name="user_tel" type="tel" autoComplete="tel" placeholder="010-0000-0000" required maxLength={30} onChange={event => event.target.setCustomValidity('')} /></label>
          <label className="inquiry-message" htmlFor="inquiry-message">문의 내용 <span>(선택)</span><textarea id="inquiry-message" name="message" rows={4} placeholder="현장 규모나 궁금한 점을 자유롭게 남겨주세요." maxLength={5000} /></label>
        </div>
        <details className="inquiry-privacy">
          <summary>개인정보 수집 및 이용 안내</summary>
          <p>고객 문의에 대한 답변 제공 및 현황 관리를 위해 소속/회사, 이름, 이메일, 전화번호를 수집합니다.</p>
          <p>동의 후 3년간 보유하고 이후 지체없이 파기합니다. 단, 법률에 의한 보존의무가 있는 경우 해당 법령에서 정한 기간 동안 보존합니다.</p>
          <p>동의를 거부할 수 있으며, 미동의 시 온라인 상담 접수가 제한됩니다.</p>
        </details>
        <label className="inquiry-consent" htmlFor="inquiry-consent"><input type="checkbox" id="inquiry-consent" name="consent" required />개인정보 수집 및 이용에 동의합니다. (필수)</label>
      </fieldset>
      {error && <p className="inquiry-error" role="alert">{error}</p>}
      <button className="site-button" type="submit" disabled={status === 'pending'}>{status === 'pending' ? '신청을 보내는 중…' : '상담 신청하기'}<span aria-hidden="true">↗</span></button>
      <p className="inquiry-note">남겨주신 연락처로 체험과 도입 방법을 안내해 드립니다.</p>
    </form>
  );
}
